import firebase from "firebase";

const firebaseConfig = {
  apiKey: "AIzaSyBlhzKfpTbtErGDS0SiAR2HSWU0tFh6zls",
  authDomain: "deep-quest.firebaseapp.com",
  databaseURL: "https://deep-quest.firebaseio.com",
  projectId: "deep-quest",
  storageBucket: "deep-quest.appspot.com",
  messagingSenderId: "231171118567",
  appId: "1:231171118567:web:b6d1e4bf10683e21bf1942",
  measurementId: "G-WZ0955PPL9",
};
// Initialize Firebase
firebase.initializeApp(firebaseConfig);
firebase.analytics();
export const db = firebase.database();
